import React, { useState, useEffect, useContext } from "react";
import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from "../operator_home/sidebar/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import "./ReconcilationVerification.css";
import PdfToImageConverter from "./elemant/PdfURLToImageConverter";
import DisplayCSV from "./elemant/CSVDisplay";
import ImageBox from "./elemant/ImageBox";
import Pagination from "./elemant/Pagination";
import ButtionArea from "./elemant/ButtionArea";
import { ReconcilationTable } from "./ReconcilationTable";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";
import { untimeToast } from "../../toast";
import FormContext from "../../context/FormContext";
import { getFileExtensionFromUrl } from "./elemant/utils";
import { toast } from "react-toastify";
import { qty } from "./elemant/Columns";
import RecoHeaderButton from "./elemant/RecoHeaderButton";
import LoadingScreen from "../LoadingScreen";

const DisplayExcel = React.lazy(() => import("./elemant/ExcelDisplay"));
function ReconcilationVerification() {
  const [reconcilationDetails, setReconcilationDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState([]);
  const [lastPage, setLastPage] = useState([]);
  const [message, setMessage] = useState("");
  const [fileURL, setFileURL] = useState("");
  const [imagesArray, setImagesArray] = useState([]);
  const [imageProperty, setImageProperty] = useState({
    width: 600,
    angle: 0,
  });
  const [disabledState, setDisabledState] = useState(false);
  const { setIsLoading } = useContext(FormContext);
  const axiosPrivate = useAxiosPrivate();
  const box_id = ReactSession.get("box_id");
  const role = ReactSession.get("role");
  const [getExtension, setExtension] = useState("");
  const [incorrectData, setIncorrectData] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(async () => {
    const data = location.state.data;
    const recoData = data.data;
    let extension = data.file_url ? getFileExtensionFromUrl(data.file_url) : null;
    setMessage(data.error_message);
    let reconcilationData = await recoData.map((row, i) => {
      return {
        ...row,
        sr_no: i + 1,
      };
    });
    let currentCount = 0;
    reconcilationData.map((row) => {
      if (row["page_no"] === currentPage) {
        currentCount = currentCount + 1;
      }
    });
    const totalPages = [...new Set(recoData.map((row) => row["page_no"]))];
    setLastPage(totalPages[totalPages.length - 1]);
    setRowsPerPage(currentCount);
    setReconcilationDetails(reconcilationData);
    setFileURL(data.file_url || "");
    setExtension(extension || "");
    if (extension === "pdf" && data.file_url) {
      fetchPdfAndConvert(data.file_url);
    }
    return () => {
      toast.dismiss();
      setIsLoading(false);
    };
  }, []);

  const fetchPdfAndConvert = async (url) => {
    const imagesList = await PdfToImageConverter(url);
    if (imagesList) {
      setImagesArray(imagesList);
    }
  };

  const RCHandler = async (id) => {
    try {
      const res = await axiosPrivate.get(`reconcilation/reconcile/${id}`);
      if (res.data.bool === false) {
        navigate("/upload");
        return;
      } else if (res.data.bool === true) {
        navigate("/reconcilation", { state: { data: res.data } });
        return;
      } else {
        navigate("/reconciled-report", { state: { data: res.data.data } });
        return;
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const viewDocuments = () => {
    if (!getExtension) {
      return null;
    }
    switch (getExtension.toLowerCase()) {
      case "pdf":
        return (
          <ImageBox
            imagesArray={imagesArray}
            currentPage={currentPage}
            imageProperty={imageProperty}
          />
        );
      case "csv":
        return <DisplayCSV url={fileURL} />;
      case "xls":
      case "xlsx":
      case "xlsb":
        return (
          <React.Suspense fallback={<LoadingScreen />}>
            <DisplayExcel url={fileURL} />
          </React.Suspense>
        );
      default:
        return null;
    }
  };

  const submitHandler = () => {
    toast.dismiss();
    setIncorrectData([]);
    const updatedData = JSON.parse(JSON.stringify(reconcilationDetails));
    if (!updatedData[0]["box_id"]) {
      updatedData.unshift({
        box_id: box_id,
      });
    }

    const reg = new RegExp(/^\d+(\.\d{1,2})?$/);
    const tempArr = [];

    updatedData.forEach((row) => {
      if (!reg.test(row.quantity) || qty.includes(row.quantity)) {
        tempArr.push(row);
        setIncorrectData((prev) => [...prev, row]);
      }
    });

    const pageNum = new Set();

    if (tempArr.length > 1) {
      let str = "";
      tempArr.map((row, i) => {
        if (i === 0) {
          return;
        }

        pageNum.add(row["page_no"]);
      });

      pageNum.forEach((row) => {
        str += `${row},`;
      });

      untimeToast(`Quantities are invalid on PAGE NO -: ${str.slice(0, -1)}`);

      return;
    }
    setIsLoading(true);
    axiosPrivate
      .post(`/reconcilation/save-reconciliation/`, updatedData)
      .then((res) => {
        RCHandler(box_id);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section className="reconcilation__verification__main">
      <Header />
      {role === '2' ? <Sidebar className="sidebar-operator-home" /> : <OtherSidebar className="sidebar-operator-home"/>}
      <section className="reconcilation__verification__body">
        <p className="reconcilation__verification__tittle flex__item__header">
          Claim Order
        </p>
        <RecoHeaderButton
          fileURL={fileURL}
          setIsLoading={setIsLoading}
          getExtension={getExtension}
          disabledState={disabledState}
        />
        <span className="register-form-user-exists-message">
          {message && message}
        </span>
        <Pagination
          data={reconcilationDetails}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          lastPage={lastPage}
        />
        <section className="reconcilation__verification__body__main">
          <div className="reconcilation__verification__image__view">
            {viewDocuments()}
          </div>
          <div className="reconcilation__verification__table">
            <ReconcilationTable
              data={reconcilationDetails}
              setData={setReconcilationDetails}
              page_no={currentPage}
              disabledState={disabledState}
              setDisabledState={setDisabledState}
            />
          </div>
        </section>
        <section className="reconcilation__verification_button__main">
          {getExtension && ["pdf"].includes(getExtension.toLowerCase()) && (
            <ButtionArea
              imageProperty={imageProperty}
              setImageProperty={setImageProperty}
            />
          )}
          <div className="reconcilation__verification__button__area">
            <button
              onClick={submitHandler}
              disabled={disabledState || !reconcilationDetails.length}
            >
              Submit
            </button>
          </div>
        </section>
      </section>
    </section>
  );
}

export default ReconcilationVerification;
